<template>
  <div class="login-content flex-lg-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden py-10 py-lg-20 px-10 p-lg-7 mx-auto mw-450px w-100">
    <div class="d-flex flex-column-fluid flex-center py-10">
      <form @submit.prevent="login()" class="form w-100" novalidate="novalidate" id="kt_login_signin_form" data-after-login-url="/start-html-pro/?page=index">
        <div class="fv-row mb-10">
          <label class="form-label fs-6 fw-bolder text-dark">Username</label>
          <input v-model="username" class="form-control form-control-lg" type="text" name="username" autocomplete="off">
        </div>
        <div class="fv-row mb-10">
          <label class="form-label fs-6 fw-bolder text-dark pt-5">Password</label>
          <input v-model="password" class="form-control form-control-lg" :class="{'is-invalid': error}" type="password" name="password" autocomplete="off">
          <div class="fv-plugins-message-container invalid-feedback">
            {{ error }}
          </div>
        </div>
        <div class="pb-lg-0 pb-5">
          <button type="submit" class="btn btn-primary fw-bolder fs-6 px-8 py-4 my-3 me-3">
            Sign In
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import store from "../stores/store";

export default {
  name: "LoginPage",

  data() {
    return {
      username: '',
      password: '',
      error: '',
    }
  },

  methods: {
    async login() {
      this.error = ''

      try {
        await store.dispatch('login', {
          username: this.username,
          password: this.password,
        })
      } catch (e) {
        this.error = 'Incorrect username or password!'
      }
    }
  }
}
</script>

<style scoped>

</style>
